/**
 * Cache to register employee document types
 * @kind cache
 * @class EmployeeDocumentTypeLookup
 * @description Custom lookup cache for EmployeeDocumentTypeLookup
 * @usage let lookup = await Grape.cache.get('EmployeeDocumentTypeLookup');
 */
export default {
	name: 'EmployeeDocumentTypeLookup',
	options: {
		schema: 'public',
		table: 'employee_document_types',
		sortfield: 'type',
		sortorder: 'ASC'
	}
};
